export enum ResourceScope {
  MYSELF = -1,
  MYTEAM = -2,
  GLOBAL = -3,
}
